module.exports = __webpack_public_path__ + "2022426:23e21cd641c426082ae7/img/featured_image@2x.94c4140.jpg";